/*  
    remove any '/devXX' from the URL 
    (so it will send the correct URL to the search API when on a dev box environment)
*/

export const devboxUrlTrimmer = (urlToTrim?: string) => (urlToTrim || "")?.replace(/\/dev[0-9]+/, "")
